import React from 'react'

import { IconProps } from '.'

const ArrowLeft: React.FC<IconProps> = ({
  size = 24,
  color = '#3E3F58',
  ...rest
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.5 17L9.5 12L14.5 7"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ArrowLeft
